// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Labels = require("../../../reason/clients/components/Labels.bs.js");
var Callout = require("../../common/Components/Callout.bs.js");
var Tooltip = require("../../../reason/common/Tooltip.bs.js");
var AgentInfo = require("../../common/Agent/AgentInfo.bs.js");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var PseudoJoin = require("../../../uikit/reason/helpers/PseudoJoin.bs.js");
var AuthSession = require("../../../utils/AuthSession.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var HtmlDisplayer = require("../../common/Components/HtmlDisplayer.bs.js");
var PropertyPrice = require("../../common/Property/PropertyPrice.bs.js");
var BuyerNeed__Status = require("../../qa/AllInBuyerNeed/BuyerNeed__Status.bs.js");
var PropertyCardImage = require("../../common/PropertyCardImage.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RentalNeed__Status = require("../../qa/AllInRentalNeed/RentalNeed__Status.bs.js");
var RentalPropertyLease = require("../../common/Property/RentalPropertyLease.bs.js");
var ForSalePropertyLabels = require("../../common/Property/ForSalePropertyLabels.bs.js");
var RentalProperty__Status = require("../../qa/AllInRentalProperty/RentalProperty__Status.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var ForSaleProperty__Status = require("../../qa/AllInForSaleProperty/ForSaleProperty__Status.bs.js");
var PropertyLocationForCard = require("../../property/PropertyLocationForCard.bs.js");
var QuietPropertyMatchPopup = require("../../client/ClientPage/QuietPropertyMatchPopup.bs.js");
var RentalPropertyAttributes = require("../../common/Property/RentalPropertyAttributes.bs.js");
var ForSalePropertyAttributes = require("../../common/Property/ForSalePropertyAttributes.bs.js");
var RentalNeedLeaseAttributes = require("../../client/RentalNeedLeaseAttributes.bs.js");
var ConversationsPageRelayCommon = require("./ConversationsPageRelayCommon.bs.js");
var ConversationPageSelectedConversationContext_broadcast_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_broadcast_graphql.bs.js");
var ConversationPageSelectedConversationContext_buyerNeed_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_buyerNeed_graphql.bs.js");
var ConversationPageSelectedConversationContext_rentalNeed_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_rentalNeed_graphql.bs.js");
var ConversationPageSelectedConversationContext_conversation_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_conversation_graphql.bs.js");
var ConversationPageSelectedConversationContext_rentalProperty_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_rentalProperty_graphql.bs.js");
var ConversationPageSelectedConversationContext_forSaleProperty_graphql = require("../../../__generated__/ConversationPageSelectedConversationContext_forSaleProperty_graphql.bs.js");
var ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql = require("../../../__generated__/ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.bs.js");

function ConversationPageSelectedConversationContext$DetailsLink(props) {
  var entity = props.entity;
  var contextAgentId = props.contextAgentId;
  var clientId = props.clientId;
  var currentUserId = AuthSession.useCurrentUserId();
  var agentIsCurrentUser = currentUserId !== undefined && contextAgentId !== undefined ? currentUserId === contextAgentId : false;
  var button = JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
        size: "small",
        icon: "ViewDetails",
        children: "View details"
      });
  if (agentIsCurrentUser && clientId !== undefined) {
    return JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: "/my_clients/" + clientId,
                children: Caml_option.some(button)
              });
  }
  var variant = entity.NAME;
  return JsxRuntime.jsx(ButtonsV5.Link.make, {
              href: variant === "RentalNeed" || variant === "BuyerNeed" ? "/client_needs/" + entity.VAL : "/properties/" + entity.VAL,
              children: Caml_option.some(button)
            });
}

var DetailsLink = {
  make: ConversationPageSelectedConversationContext$DetailsLink
};

function minBedsDisplayString(x) {
  if (x !== 1) {
    return "Minimum " + x.toString() + " beds";
  } else {
    return "Minimum 1 bed";
  }
}

var convertFragment = ConversationPageSelectedConversationContext_buyerNeed_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_buyerNeed_graphql.node, convertFragment, fRef);
}

var BuyerNeedFragment_buyerNeedMatchingType_decode = ConversationPageSelectedConversationContext_buyerNeed_graphql.Utils.buyerNeedMatchingType_decode;

var BuyerNeedFragment_buyerNeedMatchingType_fromString = ConversationPageSelectedConversationContext_buyerNeed_graphql.Utils.buyerNeedMatchingType_fromString;

var BuyerNeedFragment = {
  buyerNeedMatchingType_decode: BuyerNeedFragment_buyerNeedMatchingType_decode,
  buyerNeedMatchingType_fromString: BuyerNeedFragment_buyerNeedMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function ConversationPageSelectedConversationContext$BuyerNeed(props) {
  var buyerNeed = use(props.buyerNeed);
  var match = buyerNeed.agent;
  var agentIsCurrentUser = AuthSession.useAgentIsCurrentUser(match !== undefined ? match.id : undefined);
  var match$1 = buyerNeed.client;
  var match$2 = buyerNeed.buyerNeedMatchingType;
  var match$3 = buyerNeed.headline;
  var tmp;
  var exit = 0;
  if (agentIsCurrentUser && match$1 !== undefined) {
    tmp = Core__Option.getOr(ConversationsPageRelayCommon.Client.getClientNames(match$1.fragmentRefs), "Buyer");
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = match$2 !== undefined && (match$2 === "BROADCAST" || match$2 === "QUIET") ? (
        match$2 === "BROADCAST" ? (
            match$3 !== undefined ? match$3 : ""
          ) : "Quiet buyer"
      ) : "";
  }
  var match$4 = buyerNeed.buyerNeedMatchingType;
  var tmp$1;
  tmp$1 = match$4 !== undefined && (match$4 === "BROADCAST" || match$4 === "QUIET") && match$4 !== "BROADCAST" ? JsxRuntime.jsx(Labels.QuietBuyerLabel.make, {}) : null;
  var match$5 = buyerNeed.areas;
  var tmp$2;
  if (match$5 !== undefined) {
    var edges = match$5.edges;
    tmp$2 = edges !== undefined ? JsxRuntime.jsx(PseudoJoin.make, {
            items: Core__Array.keepSome(edges).map(function (e) {
                  return JsxRuntime.jsx(Tooltip.make, {
                              label: e.node.label,
                              children: JsxRuntime.jsx("span", {
                                    children: e.node.name,
                                    className: "inline-block md:underline md:decoration-dotted md:decoration-zinc-400"
                                  })
                            });
                }),
            with_: ", "
          }) : null;
  } else {
    tmp$2 = null;
  }
  var match$6 = buyerNeed.priceRange;
  var remarks = buyerNeed.remarks;
  var match$7 = buyerNeed.client;
  var match$8 = buyerNeed.buyerNeedMatchingType;
  var tmp$3;
  var exit$1 = 0;
  if (agentIsCurrentUser) {
    if (match$7 !== undefined) {
      tmp$3 = JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                  href: "/my_clients/" + match$7.id,
                  children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                            size: "small",
                            icon: "ViewDetails",
                            children: "View details"
                          }))
                }),
            className: "mt-4"
          });
    } else {
      exit$1 = 1;
    }
  } else if (match$8 !== undefined && (match$8 === "BROADCAST" || match$8 === "QUIET") && match$8 === "BROADCAST") {
    exit$1 = 1;
  } else {
    tmp$3 = null;
  }
  if (exit$1 === 1) {
    tmp$3 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: "/client_needs/" + buyerNeed.id,
                children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                          size: "small",
                          icon: "ViewDetails",
                          children: "View details"
                        }))
              }),
          className: "mt-4"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: tmp,
                                              className: "text-xl text-gray-700 font-semibold"
                                            }),
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                tmp$1,
                                                JsxRuntime.jsx(BuyerNeed__Status.make, {
                                                      buyerNeed: buyerNeed.fragmentRefs
                                                    })
                                              ]
                                            })
                                      ],
                                      className: "flex flex-row space-x-4 items-baseline"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: tmp$2,
                                      className: "text-gray-500 mt-4"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: match$6 !== undefined ? JsxRuntime.jsx("span", {
                                      children: match$6.minPrice.formatted + " - " + match$6.maxPrice.formatted,
                                      className: "text-tan-gold"
                                    }) : null,
                              className: "text-2xl font-medium ml-8 shrink-0"
                            })
                      ],
                      className: "flex flex-row justify-between"
                    }),
                JsxRuntime.jsx("div", {
                      children: Core__Option.getOr(buyerNeed.propertyTypes, []).map(function (p) {
                                return p.displayName;
                              }).concat(Core__Array.keepSome([Core__Option.map(buyerNeed.minBeds, (function (minBeds) {
                                          return minBedsDisplayString(minBeds);
                                        }))])).join(", "),
                      className: "text-gray-500"
                    }),
                JsxRuntime.jsx("div", {
                      children: remarks !== undefined ? JsxRuntime.jsx(HtmlDisplayer.make, {
                              text: remarks
                            }) : null
                    }),
                JsxRuntime.jsx("div", {
                      children: tmp$3
                    })
              ],
              className: "border rounded-md p-4 flex flex-col space-y-4"
            });
}

var BuyerNeed = {
  BuyerNeedFragment: BuyerNeedFragment,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$BuyerNeed
};

var convertFragment$1 = ConversationPageSelectedConversationContext_rentalNeed_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_rentalNeed_graphql.node, convertFragment$1, fRef);
}

var RentalNeedFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function ConversationPageSelectedConversationContext$RentalNeed(props) {
  var rentalNeed = use$1(props.rentalNeed);
  var match = rentalNeed.agent;
  var agentIsCurrentUser = AuthSession.useAgentIsCurrentUser(match !== undefined ? match.id : undefined);
  var match$1 = rentalNeed.areas;
  var tmp;
  if (match$1 !== undefined) {
    var edges = match$1.edges;
    tmp = edges !== undefined ? JsxRuntime.jsx(PseudoJoin.make, {
            items: Core__Array.keepSome(edges).map(function (e) {
                  return JsxRuntime.jsx(Tooltip.make, {
                              label: e.node.label,
                              children: JsxRuntime.jsx("span", {
                                    children: e.node.name,
                                    className: "inline-block md:underline md:decoration-dotted md:decoration-zinc-400"
                                  })
                            });
                }),
            with_: ", "
          }) : null;
  } else {
    tmp = null;
  }
  var match$2 = rentalNeed.priceRange;
  var remarks = rentalNeed.remarks;
  var match$3 = rentalNeed.client;
  var tmp$1;
  var exit = 0;
  if (agentIsCurrentUser && match$3 !== undefined) {
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: "/my_clients/" + match$3.id,
                children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                          size: "small",
                          icon: "ViewDetails",
                          children: "View details"
                        }))
              }),
          className: "mt-4"
        });
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp$1 = JsxRuntime.jsx("div", {
          children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: "/client_needs/" + rentalNeed.id,
                children: Caml_option.some(JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                          size: "small",
                          icon: "ViewDetails",
                          children: "View details"
                        }))
              }),
          className: "mt-4"
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: Core__Option.getOr(rentalNeed.headline, ""),
                                              className: "text-xl text-gray-700 font-semibold"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(RentalNeed__Status.make, {
                                                    rentalNeed: rentalNeed.fragmentRefs
                                                  })
                                            })
                                      ],
                                      className: "flex flex-row space-x-4 items-baseline"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: tmp,
                                      className: "text-gray-500 mt-4"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: match$2 !== undefined ? JsxRuntime.jsx("span", {
                                      children: match$2.minPrice.formatted + " - " + match$2.maxPrice.formatted + "/month",
                                      className: "text-tan-gold"
                                    }) : null,
                              className: "text-2xl font-medium ml-8 shrink-0"
                            })
                      ],
                      className: "flex flex-row justify-between"
                    }),
                JsxRuntime.jsx("div", {
                      children: Core__Option.getOr(rentalNeed.propertyTypes, []).map(function (p) {
                                return p.displayName;
                              }).concat(Core__Array.keepSome([Core__Option.map(rentalNeed.minBeds, (function (minBeds) {
                                          return minBedsDisplayString(minBeds);
                                        }))])).join(", "),
                      className: "text-gray-500"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(RentalNeedLeaseAttributes.make, {
                            rentalNeed: rentalNeed.fragmentRefs
                          })
                    }),
                JsxRuntime.jsx("div", {
                      children: remarks !== undefined ? JsxRuntime.jsx(HtmlDisplayer.make, {
                              text: remarks
                            }) : null
                    }),
                JsxRuntime.jsx("div", {
                      children: tmp$1
                    })
              ],
              className: "border rounded-md p-4 flex flex-col space-y-4"
            });
}

var RentalNeed = {
  RentalNeedFragment: RentalNeedFragment,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$RentalNeed
};

var convertFragment$2 = ConversationPageSelectedConversationContext_broadcast_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_broadcast_graphql.node, convertFragment$2, fRef);
}

var BroadcastFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function ConversationPageSelectedConversationContext$MessageBroadcast(props) {
  var broadcast = use$2(props.broadcast);
  var match = broadcast.agent;
  var body = broadcast.body;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: match !== undefined ? JsxRuntime.jsx(AgentInfo.make, {
                              agent: match.fragmentRefs
                            }) : null
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: broadcast.category.shortName,
                              className: "text-gray-400 uppercase"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("h3", {
                                    children: Core__Option.getOr(broadcast.subject, ""),
                                    className: "text-xl font-semibold"
                                  })
                            }),
                        body !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(HtmlDisplayer.make, {
                                      text: body
                                    })
                              }) : null
                      ]
                    })
              ],
              className: "border rounded-md p-4 flex flex-col space-y-2"
            });
}

var MessageBroadcast = {
  BroadcastFragment: BroadcastFragment,
  make: ConversationPageSelectedConversationContext$MessageBroadcast
};

var convertFragment$3 = ConversationPageSelectedConversationContext_forSaleProperty_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, fRef);
}

function use$3(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, fRef);
}

function useOpt$3(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3);
}

function readResolverFragment$3(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_forSaleProperty_graphql.node, convertFragment$3, fRef);
}

var PropertyFragment_forSalePropertyMatchingType_decode = ConversationPageSelectedConversationContext_forSaleProperty_graphql.Utils.forSalePropertyMatchingType_decode;

var PropertyFragment_forSalePropertyMatchingType_fromString = ConversationPageSelectedConversationContext_forSaleProperty_graphql.Utils.forSalePropertyMatchingType_fromString;

var PropertyFragment = {
  forSalePropertyMatchingType_decode: PropertyFragment_forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: PropertyFragment_forSalePropertyMatchingType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  use: use$3,
  useOpt: useOpt$3,
  readResolverFragment: readResolverFragment$3
};

function ConversationPageSelectedConversationContext$ForSaleProperty(props) {
  var property = use$3(props.property);
  var match = property.agentV2;
  var agentId;
  if (match !== undefined && match.__typename === "VisibleForSalePropertyAgent") {
    var match$1 = match.agent;
    agentId = match$1 !== undefined ? match$1.id : undefined;
  } else {
    agentId = undefined;
  }
  var match$2 = property.client;
  var clientId = match$2 !== undefined ? match$2.id : undefined;
  var match$3 = property.images;
  var imageSrc;
  if (match$3 !== undefined) {
    var match$4 = match$3.edges;
    if (match$4.length !== 1) {
      imageSrc = undefined;
    } else {
      var match$5 = match$4[0];
      imageSrc = match$5 !== undefined ? match$5.node.url : undefined;
    }
  } else {
    imageSrc = undefined;
  }
  var description = property.description;
  var match$6 = property.matchingType;
  var tmp;
  var exit = 0;
  if (match$6 !== undefined) {
    var exit$1 = 0;
    if (match$6 === "QUIET" || match$6 === "ONE_WAY" || match$6 === "BROADCAST" || match$6 === "QUIET_ANONYMOUS") {
      switch (match$6) {
        case "QUIET" :
        case "QUIET_ANONYMOUS" :
            exit$1 = 2;
            break;
        default:
          exit = 1;
      }
    } else {
      exit = 1;
    }
    if (exit$1 === 2) {
      tmp = JsxRuntime.jsx(QuietPropertyMatchPopup.FromDetailsButton.make, {
            propertyNodeId: property.nodeId
          });
    }
    
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = JsxRuntime.jsx(ConversationPageSelectedConversationContext$DetailsLink, {
          clientId: clientId,
          contextAgentId: agentId,
          entity: {
            NAME: "ForSaleProperty",
            VAL: property.id
          }
        });
  }
  return JsxRuntime.jsxs("div", {
              children: [
                imageSrc !== undefined ? JsxRuntime.jsx("div", {
                        children: JsxRuntime.jsx("img", {
                              className: "w-full h-full object-cover absolute inset-0",
                              alt: "Property image",
                              src: imageSrc
                            }),
                        className: "w-full h-32 lg:w-1/4 lg:h-auto relative"
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("div", {
                                              children: [
                                                JsxRuntime.jsx(PropertyLocationForCard.make, {
                                                      property: property.fragmentRefs
                                                    }),
                                                JsxRuntime.jsx(ForSalePropertyLabels.make, {
                                                      property: property.fragmentRefs
                                                    })
                                              ],
                                              className: "flex flex-row space-x-4"
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(ForSaleProperty__Status.make, {
                                                          property: property.fragmentRefs,
                                                          size: "sm"
                                                        }),
                                                    className: "mt-4"
                                                  })
                                            })
                                      ],
                                      className: "flex flex-col space-y-2"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(PropertyPrice.make, {
                                            property: property.fragmentRefs,
                                            size: "medium"
                                          })
                                    })
                              ],
                              className: "flex flex-col lg:flex-row justify-between gap-4 lg:items-start"
                            }),
                        description !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(HtmlDisplayer.make, {
                                      text: description
                                    })
                              }) : null,
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ForSalePropertyAttributes.make, {
                                    property: property.fragmentRefs,
                                    size: "sm"
                                  })
                            }),
                        JsxRuntime.jsx("div", {
                              children: tmp
                            })
                      ],
                      className: "flex flex-col space-y-4 p-4 border grow"
                    })
              ],
              className: "flex flex-col lg:flex-row"
            });
}

var ForSaleProperty = {
  PropertyFragment: PropertyFragment,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$ForSaleProperty
};

var convertFragment$4 = ConversationPageSelectedConversationContext_rentalProperty_graphql.Internal.convertFragment;

function waitForFragmentData$4(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, fRef);
}

function use$4(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, fRef);
}

function useOpt$4(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4);
}

function readResolverFragment$4(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_rentalProperty_graphql.node, convertFragment$4, fRef);
}

var PropertyFragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$4,
  waitForFragmentData: waitForFragmentData$4,
  use: use$4,
  useOpt: useOpt$4,
  readResolverFragment: readResolverFragment$4
};

function ConversationPageSelectedConversationContext$RentalProperty(props) {
  var property = use$4(props.property);
  var agentId = Core__Option.map(property.agent, (function (a) {
          return a.id;
        }));
  var match = property.client;
  var clientId = match !== undefined ? match.id : undefined;
  var match$1 = property.images;
  var imageFragmentRefs;
  if (match$1 !== undefined) {
    var match$2 = match$1.edges;
    if (match$2.length !== 1) {
      imageFragmentRefs = undefined;
    } else {
      var match$3 = match$2[0];
      imageFragmentRefs = match$3 !== undefined ? Caml_option.some(match$3.node.fragmentRefs) : undefined;
    }
  } else {
    imageFragmentRefs = undefined;
  }
  var description = property.description;
  return JsxRuntime.jsxs("div", {
              children: [
                imageFragmentRefs !== undefined ? JsxRuntime.jsx(PropertyCardImage.make, {
                        image: Caml_option.valFromOption(imageFragmentRefs)
                      }) : null,
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx(PropertyLocationForCard.make, {
                                                    property: property.fragmentRefs
                                                  })
                                            }),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("div", {
                                                    children: JsxRuntime.jsx(RentalProperty__Status.make, {
                                                          property: property.fragmentRefs,
                                                          size: "sm"
                                                        }),
                                                    className: "mt-4"
                                                  })
                                            })
                                      ],
                                      className: "flex flex-col space-y-2"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(PropertyPrice.make, {
                                            property: property.fragmentRefs,
                                            size: "medium"
                                          })
                                    })
                              ],
                              className: "flex flex-col lg:flex-row justify-between gap-4 lg:items-start"
                            }),
                        description !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(HtmlDisplayer.make, {
                                      text: description
                                    })
                              }) : null,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx(RentalPropertyAttributes.make, {
                                      property: property.fragmentRefs,
                                      size: "sm"
                                    }),
                                JsxRuntime.jsx(RentalPropertyLease.make, {
                                      property: property.fragmentRefs,
                                      size: "sm"
                                    })
                              ]
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(ConversationPageSelectedConversationContext$DetailsLink, {
                                    clientId: clientId,
                                    contextAgentId: agentId,
                                    entity: {
                                      NAME: "RentalProperty",
                                      VAL: property.id
                                    }
                                  })
                            })
                      ],
                      className: "flex flex-col space-y-4 p-4 border grow"
                    })
              ],
              className: "flex flex-row"
            });
}

var RentalProperty = {
  PropertyFragment: PropertyFragment$1,
  Status: undefined,
  make: ConversationPageSelectedConversationContext$RentalProperty
};

var convertFragment$5 = ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.Internal.convertFragment;

function waitForFragmentData$5(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5, fRef);
}

function use$5(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5, fRef);
}

function useOpt$5(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5);
}

function readResolverFragment$5(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.node, convertFragment$5, fRef);
}

var AgentFragment_membershipStatusV5_decode = ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.Utils.membershipStatusV5_decode;

var AgentFragment_membershipStatusV5_fromString = ConversationPageSelectedConversationContextRemovedContextCard_agent_graphql.Utils.membershipStatusV5_fromString;

var AgentFragment = {
  membershipStatusV5_decode: AgentFragment_membershipStatusV5_decode,
  membershipStatusV5_fromString: AgentFragment_membershipStatusV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$5,
  waitForFragmentData: waitForFragmentData$5,
  use: use$5,
  useOpt: useOpt$5,
  readResolverFragment: readResolverFragment$5
};

function ConversationPageSelectedConversationContext$RemovedContextCard(props) {
  var agent = useOpt$5(props.agent);
  var entityStr = ConversationsPageRelayCommon.EntityType.toString(props.entityType);
  var tmp;
  if (agent !== undefined) {
    var match = agent.membershipStatus;
    tmp = match !== undefined && (match === "ACTIVE" || match === "TERMINATED") && match !== "ACTIVE" ? "has been removed as " + agent.displayName + " no longer has an active subscription on TAN" : "has been removed from TAN";
  } else {
    tmp = "has been removed from TAN";
  }
  var title = "This " + entityStr + " " + tmp;
  return JsxRuntime.jsx(Callout.Info.make, {
              title: title
            });
}

var RemovedContextCard = {
  AgentFragment: AgentFragment,
  make: ConversationPageSelectedConversationContext$RemovedContextCard
};

var conversationContextTypeV5_decode = ConversationPageSelectedConversationContext_conversation_graphql.Utils.conversationContextTypeV5_decode;

var convertFragment$6 = ConversationPageSelectedConversationContext_conversation_graphql.Internal.convertFragment;

function waitForFragmentData$6(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, fRef);
}

function use$6(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, fRef);
}

function useOpt$6(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6);
}

function readResolverFragment$6(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageSelectedConversationContext_conversation_graphql.node, convertFragment$6, fRef);
}

var ConversationFragment_conversationContextTypeV5_fromString = ConversationPageSelectedConversationContext_conversation_graphql.Utils.conversationContextTypeV5_fromString;

var ConversationFragment = {
  conversationContextTypeV5_decode: conversationContextTypeV5_decode,
  conversationContextTypeV5_fromString: ConversationFragment_conversationContextTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$6,
  waitForFragmentData: waitForFragmentData$6,
  use: use$6,
  useOpt: useOpt$6,
  readResolverFragment: readResolverFragment$6
};

function ConversationPageSelectedConversationContext(props) {
  var conversationContext = use$6(props.conversationContext);
  if (conversationContext === undefined) {
    return null;
  }
  switch (conversationContext.__typename) {
    case "AvailableConversationContext" :
        var context = conversationContext.context;
        if (context === undefined) {
          return null;
        }
        switch (context.__typename) {
          case "BuyerNeedV5" :
              return JsxRuntime.jsx(ConversationPageSelectedConversationContext$BuyerNeed, {
                          buyerNeed: context.fragmentRefs
                        });
          case "ForSalePropertyV5" :
              return JsxRuntime.jsx(ConversationPageSelectedConversationContext$ForSaleProperty, {
                          property: context.fragmentRefs
                        });
          case "MessageBroadcast" :
              return JsxRuntime.jsx(ConversationPageSelectedConversationContext$MessageBroadcast, {
                          broadcast: context.fragmentRefs
                        });
          case "RentalNeedV5" :
              return JsxRuntime.jsx(ConversationPageSelectedConversationContext$RentalNeed, {
                          rentalNeed: context.fragmentRefs
                        });
          case "RentalPropertyV5" :
              return JsxRuntime.jsx(ConversationPageSelectedConversationContext$RentalProperty, {
                          property: context.fragmentRefs
                        });
          case "__unselected" :
              return null;
          
        }
    case "RemovedConversationContext" :
        var entityType = conversationContextTypeV5_decode(conversationContext.entityType);
        if (entityType !== undefined) {
          return JsxRuntime.jsx(ConversationPageSelectedConversationContext$RemovedContextCard, {
                      agent: Caml_option.some(conversationContext.agent.fragmentRefs),
                      entityType: entityType
                    });
        } else {
          return null;
        }
    case "__unselected" :
        return null;
    
  }
}

var Buttons;

var make = ConversationPageSelectedConversationContext;

exports.Buttons = Buttons;
exports.DetailsLink = DetailsLink;
exports.minBedsDisplayString = minBedsDisplayString;
exports.BuyerNeed = BuyerNeed;
exports.RentalNeed = RentalNeed;
exports.MessageBroadcast = MessageBroadcast;
exports.ForSaleProperty = ForSaleProperty;
exports.RentalProperty = RentalProperty;
exports.RemovedContextCard = RemovedContextCard;
exports.ConversationFragment = ConversationFragment;
exports.make = make;
/* Labels Not a pure module */
